
import { Component, Vue } from "vue-property-decorator";
import { Getter } from 'vuex-class';
import SendSmsCode from "@/components/SendSmsCode/index.vue";
import { changePasswordConfirm, changePassword } from "@/api/my";
import { validatePhoneNumber, handleLogout } from "@/utils/util";
import { encryptData } from "@/utils/encryptData";

@Component({
  components: { SendSmsCode }
})
export class changePwd extends Vue {
  @Getter mobile!: string

  isStep1 = true // 第1步：请先完成手机号码验证 第2步：设置新的密码
  // 第1步
  mobile1 = ''
  smsCode = ''
  businessId = ''
  isMobile1Err = false
  isSmsCodeErr = false
  mobileErrMsg = '请输入正确的手机号码格式'
  // 第2步
  pwd1 = ''
  pwd2 = ''
  pwdFieldType = 'password'
  isPwd2Err = false
  pwd2ErrMsg = '两次密码不一致'
  errShakeClass = 'animate__animated animate__headShake'

  mounted () {
    this.mobile1 = this.mobile
  }

  // 第1步
  onMobile1Focus () {
    this.isMobile1Err = false
  }

  onMobile1Blur (value: string) {
    if (value) {
      this.isMobile1Err = !validatePhoneNumber(value)
      this.mobileErrMsg = '请输入正确的手机号码格式'
    }
  }

  onSmsCodeInput () {
    this.isSmsCodeErr && (this.isSmsCodeErr = false)
  }

  onSendSmsCodeApiRes (res: any) {
    if (res.code === "000000") {
      this.businessId = res.data.businessId
    } else {
      this.mobileErrMsg = res.data.msg
      this.isMobile1Err = true
    }
  }

  onNext () {
    this.isSmsCodeErr && (this.isSmsCodeErr = false)
    if (!this.businessId) {
      this.$toast("请先获取验证码");
      return
    }
    const params = {
      mobile: encryptData(this.mobile1),
      businessId: this.businessId,
      smsCode: this.smsCode
    }
    changePasswordConfirm(params).then(() => {
      this.isStep1 = false
    }).catch((err) => {
      const { code, msg = '请联系管理员' } = err.data || null
      if (code === '000001') {
        if (msg.includes('验证码')) { // 验证码有误（红字提示即可）
          this.isSmsCodeErr = true
        } else { // 其他错误（toast提示）
          this.$toast(msg)
        }
      }
    })
  }

  // input输入限制（英文、数字）独立编码
  formatterInput (value) {
    return value.replace(/[^a-zA-Z\d]/g, "")
  }

  onPwdInput () {
    this.isPwd2Err && (this.isPwd2Err = false)
  }

  onSubmit () {
    if (this.pwd1 != this.pwd2) {
      this.pwd2ErrMsg = '两次密码不一致'
      this.isPwd2Err = true
      return
    }
    const params = {
      businessId: this.businessId,
      mobile: encryptData(this.mobile),
      smsCode: this.smsCode,
      password: encryptData(this.pwd1)
    }
    changePassword(params).then(() => {
      this.$toast("修改成功");
      // 退出登录
      handleLogout()
    }).catch((err) => {
      // 有误
      const { msg = '请联系管理员' } = err.data || null
      this.pwd2ErrMsg = msg
      this.isPwd2Err = true
    })
  }
}
export default changePwd
